import { render, staticRenderFns } from "./CockpitLoad.vue?vue&type=template&id=21d218a4&scoped=true"
import script from "./CockpitLoad.vue?vue&type=script&lang=js"
export * from "./CockpitLoad.vue?vue&type=script&lang=js"
import style0 from "./CockpitLoad.vue?vue&type=style&index=0&id=21d218a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d218a4",
  null
  
)

export default component.exports